function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("circle", {
  cx: 60.6,
  cy: 60.6,
  r: 60.5
}), React.createElement("rect", {
  x: 8.6,
  y: 164.6,
  width: 103.9,
  height: 335.4
}), React.createElement("path", {
  d: "M368,157.5c-49.5,1.6-80.2,37.2-91.4,52.9v-45.8H175.9V500h3.8h96.9h4V360.1v-34.3c0-0.7,0-1.6,0-2.4 c0-81,57.4-74.6,57.4-74.6s57.4-6.5,57.4,74.6c0,0.9,0,1.6,0,2.4c0,25.9,0,34.5,0,34.3V500h0.9h10.9h92.9V298.9 C501.7,139.4,368,157.5,368,157.5z"
}));

var SvgLinkedin = function SvgLinkedin(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/linkedin.c299087c.svg";
export { SvgLinkedin as ReactComponent };